<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1">
    <path
      d="M576.896 0L960 384v512a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h320.896z m-26.624 64H256a64 64 0 0 0-63.552 56.512L192 128v768a64 64 0 0 0 56.512 63.552L256 960h576a64 64 0 0 0 63.552-56.512L896 896V410.432L550.272 64z"
      fill="#BDC8DE" />
    <path d="M768 576v64H320V576zM768 704v64H320v-64z" fill="#BDC8DE" />
    <path d="M576.896 0l384 384h-320a64 64 0 0 1-64-64V0z" fill="#DEE3EE" />
    <path d="M576.896 0l384 384h-320a64 64 0 0 1-64-64V0z m229.44 320l-165.504-165.504V320H806.4z" fill="#7D8FB3" />
  </svg>
</template>

<script>
export default {
  name: 'FileIcom',
}
</script>

<style></style>
